import App from './App.svelte';

console.log('app corriendo');
const app = new App({
	target: document.body
});

export default app;